'use strict';
var Backbone = require('backbone');
var _ = require('lodash');
var StorageUtil = require('tscom-util').storageUtil;
var storage = new StorageUtil({ storageMethod: 'cookie' });

module.exports = Backbone.Model.extend({
    url: '',
    defaults: {
        eventCustomMatrix: {},
        eventPageMatrix: {},

        // contextData variables
        swid: '',
        cookieSWID: '',
        authenticatedFlag: 'false',
        registeredFlag: 'false',
        affiliateId: '', // constant
        videoNetwork: '', // constant
        oneIdClientId: '', // constant
        appName: '', // constant
        appVersion: '', // constant
        pageNameCustom: '', // constant
        siteDifferentiator: '' // constant
    },
    OS: {
        _os: null,
        _version: null,
        WINPHONE: 'winphone',
        WIN7: 'win7',
        WIN8: 'win8',
        WIN81: 'win81',
        WIN10: 'win10',
        WINVISTA: 'winvista',
        WIN2003: 'win2003',
        WINXP: 'winxp',
        WIN2K: 'win2k',
        WINNT4: 'winnt4',
        WIN98: 'win98',
        WINME: 'winme',
        WIN95: 'win95',
        WINCE: 'wince',
        IPHONE: 'iphone',
        IPAD: 'ipad',
        MACOSSNOWLEOPARD: 'macossnowleopard',
        MACOSXLEOPARD: 'macosxleopard',
        MACOSXTIGER: 'macosxtiger',
        MACOSX: 'macosx',
        MACOS9: 'macos9',
        ANDROID: 'android',
        LINUX: 'linux',
        WII: 'wii',
        PLAYBOOK: 'playbook',
        BLACKBERRY: 'blackberry',
        UNKNOWN: 'unkown'
    },
    Browser: {
        _browser: null,
        _version: null,
        OPERA: 'opera',
        SILK: 'silk',
        FLOCK: 'flock',
        GOOGLETV: 'googletv',
        EDGE: 'edge',
        CHROME: 'chrome',
        FIREFOX: 'firefox',
        MOBILESAFARI: 'mobilesafari',
        KONQUEROR: 'konqueror',
        IEMOBILE: 'iemobile',
        IE: 'ie',
        NETSCAPE: 'netscape',
        MOZILLA: 'mozilla',
        UNKNOWN: 'unkown'

    },
    /**
     *
     */
    initialize: function () {

        this.set({
            eventPageMatrix: {
                'OneID' : { // State: OneID Login Page
                    'pageName': this.get('pageNameCustom') + ':oneid login',
                    'page_name_custom': this.get('pageNameCustom') + ':oneid login',
                    'section_page': 'login'
                },
                'Vote Grid': { // State: Voting Landing Page
                    'pageName': this.get('pageNameCustom') + ':votinglanding',
                    'page_name_custom': this.get('pageNameCustom') + ':votinglanding',
                    'section_page': 'vote grid'
                },
                'Thanks': { // State: Thank You for Voting
                    'pageName': this.get('pageNameCustom') + ':confirmation',
                    'page_name_custom': this.get('pageNameCustom') + ':confirmation',
                    'section_page': 'confirmation'
                },
                'window': { // State: Voting is Now Closed
                    'pageName': this.get('pageNameCustom')+':votingclosed',
                    'page_name_custom': this.get('pageNameCustom')+':votingclosed',
                    'section_page': 'closed window'
                }
            },
            eventCustomMatrix: {
                'oneIdSignin': { // Action: One ID Sign In Initiation
                    'linkName': this.get('pageNameCustom') + ':oneid sign in initiation',
                    'linkType': 'lnk_o',
                    'event': 'event55',
                    'link_name_custom': this.get('pageNameCustom') +' :oneid sign in initiation'
                },
                'oneIdRegister': { // Action: One ID Registration Initiation
                    'linkName': this.get('pageNameCustom') + ':oneid registration initiation',
                    'linkType': 'lnk_o',
                    'event': 'event56',
                    'link_name_custom': this.get('pageNameCustom') +' :oneid registration initiation'
                },
                'registerSuccess': { // Action: One ID Registration Success
                    'linkName': this.get('pageNameCustom') + ':oneid registration success',
                    'linkType': 'lnk_o',
                    'event': 'event50',
                    'link_name_custom': this.get('pageNameCustom') +' :oneid registration success'
                },
                'loginSuccess': { // Action: One ID Login Success - If user had to click login to login
                    'linkName': this.get('pageNameCustom') + ':oneid login success',
                    'linkType': 'lnk_o',
                    'event': 'event51',
                    'link_name_custom': this.get('pageNameCustom') + ':oneid login success'
                },
                'loginConfirmation': { // Action: One ID Login Confirmation - If user comes back and is already logged in without having to click login
                    'linkName': this.get('pageNameCustom') + ':login confirmation',
                    'linkType': 'lnk_o',
                    'event': 'event58',
                    'link_name_custom': this.get('pageNameCustom') + ':login confirmation'
                },
                'logoutSuccess': { // Action: One ID Sign Out
                    'linkName': this.get('pageNameCustom') + ':oneid sign out',
                    'linkType': 'lnk_o',
                    'event': 'event54',
                    'link_name_custom': this.get('pageNameCustom') + ':oneid sign out'
                },
                'addVoteClick': { // Action: Add Vote Click
                    'linkName': this.get('pageNameCustom') + ':myvote:plus',
                    'linkType': 'lnk_o',
                    'event': 'event85',
                    'link_name_custom': this.get('pageNameCustom') + ':myvote:plus',
                    'section_page': 'vote grid'
                },
                'voteEditClick': { // Action: Edit Vote Click
                    'linkName': this.get('pageNameCustom') + ':vote:edit',
                    'linkType': 'lnk_o',
                    'event': 'event87',
                    'link_name_custom': this.get('pageNameCustom') + ':vote:edit',
                    'section_page': 'vote grid'
                },
                'voteSubmitClick': { // Action: Submit Vote Click
                    'linkName': this.get('pageNameCustom') + ':vote:submit',
                    'linkType': 'lnk_o',
                    'event': 'event86',
                    'link_name_custom': this.get('pageNameCustom') + ':vote:submit',
                    'section_page': 'vote grid'
                },
                'removeVoteClick': { // Action: Remove Vote Click
                    'linkName': this.get('pageNameCustom') + ':vote:minus',
                    'linkType': 'lnk_o',
                    'event': 'event134',
                    'link_name_custom': this.get('pageNameCustom') + ':vote:minus',
                    'section_page': 'vote grid'
                },
                'facebookShare': { // Action: Social Share - Facebook
                    'linkName': this.get('pageNameCustom') + ':facebook share',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + ':facebook share',
                    'section_page': 'confirmation'
                },
                'twitterFollow': { // Action: Social Share - Twitter Follow
                    'linkName': this.get('pageNameCustom') + ':twitter follow',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + ':twitter follow',
                    'section_page': 'confirmation'
                },
                'twitterShare': { // Action: Social Share - Twitter
                    'linkName': this.get('pageNameCustom') + ':twitter share',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + ':twitter share',
                    'section_page': 'confirmation'
                },
                'abcHeaderClick': { // Action: Global Nav Click
                    'linkName': this.get('pageNameCustom') + ':abc header',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + ':abc header',
                    'section_page': 'abc header'
                },
                'abcFooterClick': { // Action: Footer Click
                    'linkName': this.get('pageNameCustom') + ':abc footer',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + ':abc footer',
                    'section_page': 'abc footer'
                },
                'simpleClick': { // Action: Simple Click
                    'linkName': this.get('pageNameCustom') + ':confirmation',
                    'linkType': 'lnk_o',
                    'event': '',
                    'link_name_custom': this.get('pageNameCustom') + 'confirmation',
                    'section_page': 'confirmation'
                }
            }
        });

        // this is what will be used when user is not logged in
        this.set({ cookieSWID: storage.fetch('SWID') });

        /* eslint-disable */
        if(typeof s !== 'undefined'){
            s.pageName = '';
            s.linkName = '';
            s.linkType = '';
            s.channel = this.get('pageNameCustom');
        }
        /* eslint-enable */

        this.setContextData();
    },
    /**
     *
     */
    setContextData: function(){
        var ua = navigator.userAgent;
        /* eslint-disable */
        if(typeof s !== 'undefined') {

            // device: Name of the device
            s.contextData['device'] = this.getOS();

            // device_type: Type of device
            if( (ua.match(/Android/i) && ua.match(/mobile/i)) || ua.match(/iPad/i) ) {
                s.contextData['device_type'] = 'tablet';
            } else if ( ua.match(/webOS/i)
             || ua.match(/iPhone/i)
             || ua.match(/iPod/i)
             || ua.match(/BlackBerry/i)
             || ua.match(/Windows Phone/i)
             || ua.match(/IE Mobile/i)) {
                s.contextData['device_type'] = 'phone';
            } else {
                s.contextData['device_type'] = 'computer';
            }

            // device_version: Version of device
            s.contextData['device_version'] = (this.getOS() || 'unkown').toLowerCase() + (this.getBrowserName() || 'unkown');

            // platform: Name of the OS
            s.contextData['platform'] = this.getOS();

            // os_version: OS version
            s.contextData['os_version'] = this.getOSVersion();

            // video_network: Network the show airs on
            s.contextData['video_network'] = this.get('videoNetwork');

            // oneid_clientid: Client ID of the OneID implementation
            s.contextData['oneid_clientid'] = this.get('oneIdClientId');

            // app_name: Name of the app
            s.contextData['app_name'] = this.get('appName');

            // app_version: Version of the app
            s.contextData['app_version'] = this.get('appVersion');

            // campaign_id: If the user accesses the sweepstakes site with a url that contains a campaign id (cid),
            // the cid value should be captured.
            if(typeof _.getQueryParamByName('cid') !== 'undefined' && _.getQueryParamByName('cid')) {
                s.contextData['campaign_id'] = _.getQueryParamByName('cid');
            } else {
                s.contextData['campaign_id'] = '';
            }

            // site_differentiator: Differentiates site from apps and ott
            s.contextData['site_differentiator'] = this.get('siteDifferentiator');

            // site_section_level: Site map level
            s.contextData['site_section_level2'] = this.get('pageNameCustom');
            s.contextData['site_section_level3'] = this.get('pageNameCustom');
            s.contextData['site_section_level4'] = this.get('pageNameCustom');

            // orientation: Interface Orientation
            if(window.innerWidth > window.innerHeight) s.contextData['orientation'] = 'landscape';
            else s.contextData['orientation'] = 'portrait';

            // swid: OneID information
            s.contextData['swid'] = this.get('swid').length > 0 ? this.get('swid') : this.get('cookieSWID');

            // registered_user_flag: Pass "true" if user is registered with OneID, "false" if user is not registered yet
            s.contextData['registered_user_flag'] = this.get('registeredFlag');

            // authenticated_user_flag: Pass "true" if user is logged in, "false" if user is not
            s.contextData['authenticated_user_flag'] = this.get('authenticatedFlag');

            // affiliate_id: Local Affiliate ID (For ABC Only)
            s.contextData['affiliate_id'] = this.get('affiliateId');

        }
        /* eslint-enable */
    },
    /**
     * Reset the values of custom properties
     */
    clearVars: function () {

        console.log('Omniture: clearVars');
        /* eslint-disable */
        if(typeof s !== 'undefined'){
            s.pageName = '';
            s.linkName = '';
            s.linkType = '';
            s.channel = '';

            s.contextData['event'] = '';
            s.contextData['link_name_custom'] = '';
            s.contextData['page_name_custom'] = '';
            s.contextData['cta_text'] = '';
            s.contextData['section_page'] = '';
        }
        /* eslint-enable */
    },
    /**
     *
     */
    logPage: function (page) {
        console.log('Omniture Log Page:',page);
        this.clearVars();

        /* eslint-disable */
        if(typeof s !== 'undefined'){

            var obj = this.get('eventPageMatrix')[page];
            if(_.isUndefined(obj)) {
                return false;
            }

            _.each(obj,function(value,key){
                if(key == 'section_page' || key == 'page_name_custom') {
                    s.contextData[key] = value;
                } else {
                    s[key] = value;
                }
            });

            s.channel = this.get('pageNameCustom');
        }

        this.setContextData();

        if(typeof s !== 'undefined'){
            console.log('Omniture: logPage', page, s.pageName, s.contextData);
            //for reference: https://marketing.adobe.com/resources/help/en_US/sc/implement/function_t.html
            s.t();
        }
        /* eslint-enable */
    },
    /**
     *
     */
    logEventCustom: function (action,ctaText) {
        this.clearVars();

        /* eslint-disable */
        if(typeof s !== 'undefined') {

            var obj = this.get('eventCustomMatrix')[action];
            if(_.isUndefined(obj)) {
                return false;
            }

            _.each(obj,function(value,key){
                if(key == 'event' || key == 'link_name_custom' || key == 'section_page') {
                    s.contextData[key] = value;
                } else {
                    s[key] = value;
                }
            });

            s.channel = this.get('pageNameCustom');

            if(action == 'abcFooterClick' || action == 'abcHeaderClick' || action == 'simpleClick') {
                var linkNameCustom = obj.linkName + ':' + ctaText;
                s.contextData['link_name_custom'] = linkNameCustom;
            }

            if(ctaText) s.contextData['cta_text'] = ctaText;
        }

        this.setContextData();

        if(typeof s !== 'undefined'){
            console.log('Omniture: logEventCustom', action, ctaText, s.contextData);
            // for reference: https://marketing.adobe.com/resources/help/en_US/sc/implement/function_tl.html
            s.tl(true, 'o', s.linkName);
        }
        /* eslint-enable */
    },
    getOS: function() {
        if (this.OS._os === null) {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('windows') !== -1) {
                // windows 8 example:
                //"Mozilla/5.0 (compatible; MSIE 10.0; Windows Phone 8.0; Trident/6.0; IEMobile/10.0; ARM; Touch; NOKIA; Lumia 920)"

                // windows NT example:
                //"Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko"
                var windowsStringIndex = ua.indexOf('windows');
                var windowsSubstring = ua.substring(windowsStringIndex);
                this._osVersion = windowsSubstring.split(';')[0];
                if (ua.indexOf('windows phone') !== -1) this.OS._os = this.OS.WINPHONE;
                else if (ua.indexOf('windows nt 6.1') !== -1) this.OS._os = this.OS.WIN7;
                else if (ua.indexOf('windows nt 6.2') !== -1) this.OS._os = this.OS.WIN8;
                else if (ua.indexOf('windows nt 6.3') !== -1) this.OS._os = this.OS.WIN81;
                else if (ua.indexOf('windows nt 6.4') !== -1 || ua.indexOf('windows nt 10.0') !== -1) this.OS._os = this.OS.WIN10;
                else if (ua.indexOf('windows nt 6.0') !== -1 || ua.indexOf('window nt6.0') !== -1) this.OS._os = this.OS.WINVISTA;
                else if (ua.indexOf('windows nt 5.2') !== -1 || ua.indexOf('windows 5.2') !== -1) this.OS._os = this.OS.WIN2003;
                else if (ua.indexOf('windows nt 5.1') !== -1 || ua.indexOf('windows xp') !== -1) this.OS._os = this.OS.WINXP;
                else if (ua.indexOf('windows nt 5.0') !== -1 || ua.indexOf('windows 2000') !== -1) this.OS._os = this.OS.WIN2K;
                else if (ua.indexOf('windows nt 4.0') || ua.indexOf('winnt4.0') || ua.indexOf('winnt')) this.OS._os = this.OS.WINNT4;
                else if (ua.indexOf('windows 98') !== -1 || ua.indexOf('win98') !== -1) this.OS._os = this.OS.WIN98;
                else if (ua.indexOf('windows me') !== -1 || ua.indexOf('win 9x 4.90') !== -1) this.OS._os = this.OS.WINME;
                else if (ua.indexOf('windows 95') !== -1 || ua.indexOf('win95') !== -1) this.OS._os = this.OS.WIN95;
                else if (ua.indexOf('windows ce') !== -1) this.OS._os = this.OS.WINCE;
            } else if (ua.indexOf('mac') !== -1) {

                //iPhone example:
                //HTTP_USER_AGENT=Mozilla/5.0 (iPhone; U; CPU like Mac OS X; en) AppleWebKit/420+ (KHTML, like Gecko) Version/3.0 Mobile/1C25 Safari/419.3

                //iPad example:
                //Mozilla/5.0 (iPad; U; CPU OS 3_2 like Mac OS X; en-us) AppleWebKit/531.21.10 (KHTML, like Gecko) Version/4.0.4 Mobile/7B334b Safari/531.21.10

                var macVersionIndex = ua.indexOf('version');
                this._osVersion = ua.substring(macVersionIndex);

                if (ua.indexOf('iphone') !== -1) {
                    this.OS._os = this.OS.IPHONE;
                } else if (ua.indexOf('ipad') !== -1) {
                    this.OS._os = this.OS.IPAD;
                } else {
                    if (ua.indexOf('mac os x 10.6') !== -1 || ua.indexOf('intel mac os x 10_6') !== -1) this.OS._os = this.OS.MACOSSNOWLEOPARD;
                    else if (ua.indexOf('mac os x 10.5') !== -1 || ua.indexOf('intel mac os x 10_5') !== -1) this.OS._os = this.OS.MACOSXLEOPARD;
                    else if (ua.indexOf('mac os x 10.4') !== -1 || ua.indexOf('intel mac os x 10_4') !== -1) this.OS._os = this.OS.MACOSXTIGER;
                    else if (ua.indexOf('mac os x') !== -1) this.OS._os = this.OS.MACOSX;
                    else this.OS._os = this.OS.MACOS9;
                }

            } else if (ua.indexOf('android') !== -1) {
                this.OS._os = this.OS.ANDROID;
            } else if (ua.indexOf('linux') !== -1) {
                this.OS._os = this.OS.LINUX;
            } else if (ua.indexOf('nintindo wii') !== -1) {
                this.OS._os = this.OS.WII;
            } else if (ua.indexOf('playbook') !== -1) {
                this.OS._os = this.OS.PLAYBOOK;
            } else if (ua.indexOf('blackberry') !== -1) {
                this.OS._os = this.OS.BLACKBERRY;
            } else {
                this.OS._os = this.OS.UNKNOWN;
            }

        }
        return this.OS._os;
    },
    getBrowserName: function() {
        // http://www.useragentstring.com/
        // http://developer.apple.com/internet/safari/faq.html#anchor2
        // private function for trim user agent pieces to just retain the version number

        var _trimv = function(version) {
            var so = null;
            if (version) {
                so = version.split(' ')[0];
                so = so.replace(';', '');
                so = so.replace(')','');
            }
            return so;
        };

        if (this.Browser._browser === null) {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('opera') !== -1 || ua.indexOf('opr') !== -1) {
                this.Browser._browser = this.Browser.OPERA;
                this.Browser._version = _trimv(ua.split('opera/')[1]) || _trimv(ua.split('opr/')[1]) || _trimv(ua.split('opera ')[1]);
            } else if (ua.indexOf('silk') !== -1) {
                this.Browser._browser = this.Browser.SILK;
                this.Browser._version = _trimv(ua.split('silk/')[1]);
            } else if (ua.indexOf('flock') !== -1) {
                this.Browser._browser = this.Browser.FLOCK;
                this.Browser._version = _trimv(ua.split('flock/')[1]);
            } else if (ua.indexOf('googletv') !== -1 && ua.indexOf('gecko') !== -1) {
                this.Browser._browser = this.Browser.GOOGLETV;
                this.Browser._version = _trimv(ua.split('googletv/')[1]);
            } else if (ua.indexOf('edge') !== -1) {
                this.Browser._browser = this.Browser.EDGE;
                this.Browser._version = _trimv(ua.split('edge/')[1]);
            } else if (ua.indexOf('chrome') !== -1) {
                this.Browser._browser = this.Browser.CHROME;
                this.Browser._version = _trimv(ua.split('chrome/')[1]);
            } else if (ua.indexOf('firefox') !== -1) {
                this.Browser._browser = this.Browser.FIREFOX;
                this.Browser._version = _trimv(ua.split('firefox/')[1]);
            } else if (ua.indexOf('webkit') !== -1 && ua.indexOf('safari') !== -1) {
                this.Browser._browser = (ua.indexOf('mobile/') !== -1) ? this.Browser.MOBILESAFARI : this.Browser.SAFARI;
                this.Browser._version = _trimv(ua.split('version/')[1]) || _trimv(ua.split('safari/')[1]);
            } else if (ua.indexOf('konqueror') !== -1) {
                this.Browser._browser = this.Browser.KONQUEROR;
                this.Browser._version = _trimv(ua.split('konqueror/')[1]);
            } else if (ua.indexOf('iemobile') !== -1) {
                this.Browser._browser = this.Browser.IEMOBILE;
                this.Browser._version = _trimv(ua.split('iemobile/')[1]);
            } else if (ua.indexOf('msie') !== -1) {
                this.Browser._browser = this.Browser.IE;
                this.Browser._version = _trimv(ua.split('msie ')[1]);
            } else if (ua.indexOf('trident') !== -1) {
                this.Browser._browser = this.Browser.IE;
                this.Browser._version = ua.match(/rv:(\d*\.\d*)/i)[1];
            } else if (ua.indexOf('netscape') !== -1) {
                this.Browser._browser = this.Browser.NETSCAPE;
                this.Browser._version = _trimv(ua.split('netscape ')[1]);
            } else if (ua.indexOf('mozilla') !== -1 && ua.indexOf('gecko') !== -1) {
                this.Browser._browser = this.Browser.MOZILLA;
                this.Browser._version = _trimv(ua.split('mozilla/')[1]);
            } else {
                this.Browser._browser = this.Browser.UNKNOWN;
            }
        }

        return this.Browser._browser;

    },
    getBrowserVersion: function() {
        return this.Browser._version;

    },
    getOSVersion: function() {

        if(this.OS._version === null) {
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            // system
            var os = 'unknown';
            var clientStrings = [
                {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
                {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
                {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
                {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
                {s:'Windows Vista', r:/Windows NT 6.0/},
                {s:'Windows Server 2003', r:/Windows NT 5.2/},
                {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
                {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
                {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
                {s:'Windows 98', r:/(Windows 98|Win98)/},
                {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
                {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
                {s:'Windows CE', r:/Windows CE/},
                {s:'Windows 3.11', r:/Win16/},
                {s:'Android', r:/Android/},
                {s:'Open BSD', r:/OpenBSD/},
                {s:'Sun OS', r:/SunOS/},
                {s:'Linux', r:/(Linux|X11)/},
                {s:'iOS', r:/(iPhone|iPad|iPod)/},
                {s:'Mac OS X', r:/Mac OS X/},
                {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
                {s:'QNX', r:/QNX/},
                {s:'UNIX', r:/UNIX/},
                {s:'BeOS', r:/BeOS/},
                {s:'OS/2', r:/OS\/2/},
                {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
            ];
            /* eslint-disable */
            for (var id in clientStrings) {
                var cs = clientStrings[id];
                if (cs.r.test(nAgt)) {
                    os = cs.s;
                    break;
                }
            }
            /* eslint-enable */
            var osVersion = 'unknown';

            if (/Windows/.test(os)) {
                osVersion = /Windows (.*)/.exec(os)[1];
                os = 'Windows';
            }

            switch (os) {

            case 'Mac OS X':
                osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1];
                break;

            case 'Android':
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                break;
            }
            this.OS._version = osVersion.replace(/[^\w\s]/gi, '-');
        }
        return this.OS._version;
    }
});



// WEBPACK FOOTER //
// ./app/scripts/models/omniture.js